import { useEffect, useState } from "react";
import { getTop10Guides } from "@/api/content";
import { getBrandConfig } from "@/config/brand";
import type { PostCard } from "@/types/content";
import ArticleCard from "@/components/base/ArticleCard";
import SectionSkeleton from "@/components/base/SectionSkeleton";
import { extractLocation } from "@/utils/extractLocation";

export default function Top10Guides() {
  const [guides, setGuides] = useState<PostCard[]>([]);
  const [loading, setLoading] = useState(true);
  const config = getBrandConfig().top10Guides;
  const global = getBrandConfig().global;

  useEffect(() => {
    getTop10Guides(6).then((data) => {
      setGuides(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <h2 className="section-title">
              <i className="ri-trophy-line text-accent text-xl md:text-2xl w-6 h-6 flex items-center justify-center" />
              {config.title}
            </h2>
          </div>
          <SectionSkeleton type="cards" count={6} columns={3} surface="white" aspectRatio="16/10" footerLines={1} />
        </div>
      </section>
    );
  }

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="section-title">
            <i className="ri-trophy-line text-accent text-xl md:text-2xl w-6 h-6 flex items-center justify-center" />
            {config.title}
          </h2>
          <a
            href="/articles"
            className="text-sm text-slate-500 hover:text-primary transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            {global.viewAll}
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {guides.map((guide) => (
            <ArticleCard
              key={guide.id}
              post={guide}
              imageOverlay={
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-white text-xs font-medium flex items-center gap-1">
                    <i className="ri-map-pin-line" />
                    {extractLocation(guide.tags)}
                  </span>
                </div>
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}